<template>
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Stages</li>
            </ol>
            <h4 class="main-title mb-0">Stages</h4>
        </div>
        <div>
        <router-link to="/stages" class="btn btn-danger me-2"><i class="ri-close-line fs-18 lh-1"></i> Back</router-link>
        <button class="btn btn-primary " @click.prevent="submitForm()">
                        <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                        <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                    </button>
                </div>
        
    </div>
    <div class="row g-3">
        <div class="col-sm-12">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">New Stage</h6>
                    <nav class="nav ms-auto"></nav>
                </div>
                <div class="card-body">
                    <div class="row g-2 mb-3">
                        <div class="col-md-3">
                            <label class="form-label">Stage Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Stage Name" class="form-control" :class="{ 'is-invalid': errors.stage_name }" v-model="stage.stage_name" ref="stage_name" />
                            <span v-if="errors.stage_name"><small class="text-danger">{{ errors.stage_name[0] }}</small></span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Stage Type</label><span class="text-danger"> *</span>
                            <select class="form-control" :class="{ 'is-invalid': errors.stage_type }" v-model="stage.stage_type">
                                <option value="">Select Stage type</option>
                                <option value="inward">Inward</option>
                                <option value="outward">Outward</option>
                            </select>
                            <span v-if="errors.stage_type"><small class="text-danger">{{ errors.stage_type[0] }}</small></span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Order</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Order" class="form-control" :class="{ 'is-invalid': errors.order }" v-model="stage.order" />
                            <span v-if="errors.order"><small class="text-danger">{{ errors.order[0] }}</small></span>
                        </div>
                        <div class="col-md-3">
                            <!-- <label class="form-label">loading_types</label>
                            <div class="dropdown" @click="showDropdown()">
                                <div class="overselect"></div>
                                <select class="form-control">
                                    <option value="">Select Customer</option>
                                </select>
                            </div> -->
                            <label class="form-label">Loading Types</label><span class="text-danger" v-if="stage.stage_type=='outward'"> *</span>
                            <select class="form-control" :class="{ 'is-invalid': errors.loading_type_id }" v-model="stage.loading_type_id">
                                <option value="">Select Loading Type</option>
                                <option v-for="loading_type, key in loading_types" :key=key :value="loading_type.loading_type_id">{{ loading_type.loading_type_name }}</option>
                            </select>
                            <span v-if="errors.loading_type_id"><small class="text-danger">{{ errors.loading_type_id[0] }}</small></span>
                        </div>
                    </div>

                    <div class="row g-2">
                        <div class="col-md-12">
                            <div class="table-responsive table-responsive-sm">
                                <table class="table table-sm text-wrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th>Check Name<span class="text-danger"> *</span></th>
                                            <th>Field Type<span class="text-danger"> *</span></th>
                                            <th>Default Value<span class="text-danger"> *</span></th>
                                            <th>Min <span class="text-danger" v-if="check.field_type=='number'"> *</span></th>
                                            <th>Max <span class="text-danger" v-if="check.field_type=='number'"> *</span></th>
                                            <th>Field Values</th>
                                            <th>Order<span class="text-danger"> *</span></th>
                                            <th v-if="check.field_type == 'radio'">Is Image Required</th>
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input text="text" class="form-control" placeholder="Check Name" :class="{ 'is-invalid': errors.check_name }" v-model="check.check_name" />
                                                <span v-if="errors.check_name" class="invalid-feedback">{{ errors.check_name[0] }}</span>
                                            </td>
                                            <td>
                                                <select class="form-control" :class="{ 'is-invalid': errors.field_type}" v-model="check.field_type">
                                                    <option value="text">Text</option>
                                                    <option value="number">Number</option>
                                                    <option value="radio">Radio</option>
                                                    <option value="select">Select</option>
                                                </select>
                                                <span v-if="errors.field_type" class="invalid-feedback">{{ errors.field_type[0] }}</span>
                                            </td>

                                            <td>
                                                <input type="text" placeholder="Default Value" class="form-control" :class="{ 'is-invalid': errors.default_value }" v-model="check.default_value" />
                                                <span v-if="errors.default_value" class="invalid-feedback">{{ errors.default_value[0] }}</span>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Min" class="form-control" :class="{ 'is-invalid': errors.min }" v-model="check.min" />
                                                <span v-if="errors.min" class="invalid-feedback">{{ errors.min[0] }}</span>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Max" class="form-control" :class="{ 'is-invalid': errors.max }" v-model="check.max" />
                                                <span v-if="errors.max" class="invalid-feedback">{{ errors.max[0] }}</span>
                                            </td>
                                            <td>
                                                <input v-if="check.field_type == 'text' || check.field_type == 'number' || check.field_type == 'radio'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.field_values }" v-model="check.field_values" />
                                                <input v-else-if="check.field_type == 'dropdown'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.dropdown }" v-model="check.field_values" />
                                                <input v-else-if="check.field_type == 'select'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.select }" v-model="check.field_values" />
                                                <span v-if="errors.field_values" class="invalid-feedback">{{ errors.field_values[0] }}</span>
                                                <span v-if="errors.dropdown" class="invalid-feedback">{{ errors.dropdown[0] }}</span>
                                                <span v-if="errors.select" class="invalid-feedback">{{ errors.select[0] }}</span>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Order" class="form-control" :class="{ 'is-invalid': errors.check_order }" v-model="check.order" />
                                                <span v-if="errors.check_order" class="invalid-feedback">{{ errors.check_order[0] }}</span>
                                            </td>
                                            <td v-if="check.field_type == 'radio'" style="width:130px; text-align: center;"><div class="form-check form-check-inline mt-1">
                                                <input class="form-check-input " type="checkbox" :checked="check.is_image_required" v-model="check.is_image_required" id="flexCheckDefault">
                                                <label class="form-check-label" for="flexCheckDefault"></label>
                                            </div>
                                            </td>
                                            <td class="text-center">
                                                <button v-if="formStatus" @click="addRow()" class="btn btn-sm btn-primary"><i class="ri-add-line"></i></button>
                                                <button v-else @click="updateRow()" class="btn btn-sm btn-primary"><i class="ri-save-line"></i></button>
                                            </td>
                                        </tr>
                                        <tr v-for="(check, key) in stage.checks" :key="key">
                                            <td>{{ check.check_name }}</td>
                                            <td>{{ check.field_type }}</td>
                                            <td>{{ check.default_value }}</td>
                                            <td>{{ check.min }}</td>
                                            <td>{{ check.max}}</td>
                                            <td>{{ check.field_values }}</td>
                                            <td>{{ check.order}}</td>
                                             <td>{{ check.is_image_required }}</td>
                                            <td class="text-center d-flex">
                                                <button class="btn btn-outline-success me-2" data-toggle="tooltip" data-placement="bottom" title="Edit" @click="editRow(check,key)">
                                                    <i class="ri-pencil-line fs-18 lh-1"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" type="button" @click="deleteRow(check,key)">
                                                    <i class="ri-delete-bin-line fs-18 lh-1"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                show: false,
                stage: {
                    stage_id: '',
                    stage_name: '',
                    stage_type: '',
                    order: '',
                    loading_type_id:'',
                    checks: [],
                    deleted_checks: [],
                },
                check: {
                    check_id: "",
                    check_name: "",
                    field_type: "text",
                    default_value: "",
                    min: "",
                    max: "",
                    field_values: "",
                    order: "",
                    order: "",
                    is_image_required:false,
                },
                status: true,
                formStatus: true,
                stages: [],
                errors: [],
                loading_types:[]
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name == "Stages.Create") {
                    vm.$refs.stage_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getStage", data: { stage_id: to.params.stage_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.stage = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
                vm.getLoadingTypes()
            });
        },

        methods: {
            showDropdown() {
                this.show = !this.show;
            },
            getLoadingTypes() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "getLoadingTypes" })
                    .then((response) => {
                        vm.loading_types = response.data.data
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addStage();
                } else {
                    vm.updateStage();
                }
            },
            addRow() {
                let vm = this;
                
                if(vm.isEmpty()){
                    vm.stage.checks.push({
                        check_name: vm.check.check_name,
                        field_type: vm.check.field_type,
                        default_value: vm.check.default_value,
                        min: vm.check.min,
                        max: vm.check.max,
                        field_values: vm.check.field_values,
                        order: vm.check.order,
                        is_image_required: vm.check.is_image_required,
                    });
                    vm.discardForm();
                }
            },
            isEmpty() {
                let vm = this
                if(!vm.check.check_name){
                    vm.errors.check_name = ["Check name field cannot be empty"]
                }else{
                    delete vm.errors.check_name
                }
                if(!vm.check.default_value){
                    vm.errors.default_value = ["Default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if(!vm.check.order){
                    vm.errors.check_order = ["Check order field cannot be empty"]
                }else{
                    var number_regex=/^\d+$/
                    var validate_order = number_regex.test(vm.check.order)
                    if(!validate_order){
                        vm.errors.check_order = ["The order field must be integer"]
                    }else{
                        delete vm.errors.check_order
                    }
                }
                if(!vm.check.default_value){
                    vm.errors.default_value = ["default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if (vm.check.field_type =='number' && !vm.check.min) {
                    vm.errors.min = ["Min field cannot be empty"];
                 } else if(vm.check.field_type != 'number' && vm.check.min) {
                    var number_regex = /^\d+(\.\d+)?$/;
                    var validate_min = number_regex.test(vm.check.min);
                    if (!validate_min) {
                        vm.errors.min = ["The min field must be a number"];
                    } else {
                        delete vm.errors.min
                    }
                }else{
                    delete vm.errors.min
                }
                if(vm.check.field_type == 'number' && !vm.check.max){
                    vm.errors.max = ["Max field cannot be empty"]
                }else if(vm.check.field_type != 'number' && vm.check.max) {
                    var number_regex = /^\d+(\.\d+)?$/;
                    var validate_max = number_regex.test(vm.check.max);
                    if (!validate_max) {
                        vm.errors.max = ["The max field must be a number"];
                     }else{
                        delete vm.errors.max
                    }
                }else{
                    delete vm.errors.max
                } 
                if(vm.check.field_type == 'number' && vm.check.min && vm.check.max){
                    if(vm.check.min > vm.check.max){
                        vm.errors.min = ["The min value should be less than max"];
                        vm.errors.max = ["The max value should be more than min"];
                    }else{
                        delete vm.errors.min
                        delete vm.errors.max
                    }
                }  
                if(!vm.check.default_value){
                    vm.errors.default_value = ["default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if((vm.check.field_type == 'radio' || vm.check.field_type == 'select') && !vm.check.field_values){
                    vm.errors.field_values = ["Field values field cannot be empty"]
                }else{
                    delete vm.errors.field_values
                }
                if(!vm.check.default_value){
                    vm.errors.default_value = [" default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                for(var prop in this.errors) {
                    if(this.errors.hasOwnProperty(prop))
                        return false;
                }
                return true;
            },
            validateRow(){

            },
            editRow(check1, key) {
                let vm = this;
                vm.check = check1;
                // console.log("check"vm.check
                vm.check.order = vm.check.order;
                vm.formStatus = false;
                vm.check.key = key;
                vm.errors = [];
            },
            
            updateRow() {
                let vm = this;
                vm.check.order = vm.check.order;
                if(vm.isEmpty()){
                    vm.stage.checks.push({
                        check_id: vm.check.check_id,
                        check_name: vm.check.check_name,
                        field_type: vm.check.field_type,
                        default_value: vm.check.default_value,
                        min: vm.check.min,
                        max: vm.check.max,
                        field_values: vm.check.field_values,
                        order: vm.check.order,
                        is_image_required: vm.check.is_image_required,
                    });
                    vm.stage.checks.splice(vm.check.key, 1);
                    vm.discardForm();
                }
            },
            deleteRow(check, key) {
                let vm = this;
                vm.stage.deleted_checks.push(check.check_id), vm.stage.checks.splice(key, 1);
                vm.discardForm();
            },
            discardForm() {
                let vm = this;
                vm.check.check_name = "";
                vm.check.field_type = "text";
                vm.check.default_value = "";
                vm.check.min = "";
                vm.check.max = "";
                vm.check.field_values = "";
                vm.check.order = "";
                vm.check.is_image_required = false;
                vm.formStatus = true;
                vm.errors = [];
            },
            addStage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addStage", data: vm.stage })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Stage is successfully created");
                        vm.$router.push("/stages");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateStage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateStage", data: vm.stage })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Stage is successfully updated");
                        vm.$router.push("/stages");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
        },
    };
</script>
<style scoped>
   .dropdown {
        position: relative;
        cursor: pointer;
    }
    .multiselect {
        position: absolute;
    }
    .multiselect ul {
        border: 1px solid #ddd;
        border-top: 0;
        border-radius: 0 0 3px 3px;
        left: 0px;
        padding: 8px 8px;
        top: -0.1rem;
        width: 100%;
        list-style: none;
        max-height: 150px;
        overflow: auto;
        background: white;
    }
    .overselect {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>
